"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var oauth_1 = require("../routes/oauth");
var cross_fetch_1 = require("cross-fetch");
var index_1 = require("../index");
var rxjs_1 = require("rxjs");
var qs = require("qs");
var transform_1 = require("./transform");
var ApiError = (function (_super) {
    __extends(ApiError, _super);
    function ApiError(message, data, status) {
        var _this = _super.call(this, message) || this;
        _this.response = null;
        _this.errorCollection = [];
        _this.message = message;
        _this.status = status;
        try {
            _this.response = JSON.parse(data);
            _this.isObject = true;
        }
        catch (e) {
            _this.response = data;
            _this.isObject = false;
        }
        if (_this.isObject && _this.response.errors) {
            _this.errorCollection = _this.response.errors;
        }
        return _this;
    }
    ApiError.prototype.toString = function () {
        return this.message + "\nResponse:\n" + (this.isObject ? JSON.stringify(this.response, null, 2) : this.response);
    };
    return ApiError;
}(Error));
function buildRequestParams(path, options) {
    if (options === void 0) { options = {}; }
    var fullPath = index_1.default.getVersion() + "/" + path;
    fullPath = fullPath
        .split("/")
        .reduce(function (acc, chunk) {
        if (chunk.length) {
            acc.push(chunk);
        }
        return acc;
    }, [])
        .join("/");
    if (Object.keys(options.query || {}).length) {
        fullPath += "?" + qs.stringify(options.query);
    }
    var baseUrl = index_1.default.getUrl().replace(/\/$/, "");
    var url = baseUrl + "/" + fullPath;
    return {
        options: lodash_1.omit(options, ["query"]),
        url: url,
    };
}
function callBackend(url, options) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var logChunks, response, body, error_1, responseError;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    logChunks = {
                        Request: {
                            method: options.method || "GET",
                            url: url,
                            body: ((_b = (_a = options) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b["Content-Type"]) === "application/json" ? options.body : "not-json",
                        },
                        Response: null,
                    };
                    response = null;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    return [4, cross_fetch_1.default(url, options)];
                case 2:
                    response = _c.sent();
                    return [4, response.text()];
                case 3:
                    body = _c.sent();
                    try {
                        body = body ? JSON.parse(body) : null;
                    }
                    catch (err) {
                    }
                    logChunks.Response = { status: response.status, body: body };
                    index_1.default.log("Request", logChunks);
                    if (response.status < 200 || response.status >= 300) {
                        throw body;
                    }
                    if (response.status === 204) {
                        return [2, { status: "Succeeded" }];
                    }
                    if (lodash_1.isObject(body)) {
                        return [2, transform_1.toCamelCase(body)];
                    }
                    return [2, body];
                case 4:
                    error_1 = _c.sent();
                    if (response) {
                        responseError = new ApiError("Request failed with status " + response.status + ".", error_1, response.status);
                        if (responseError instanceof ApiError &&
                            responseError.errorCollection.some(function (e) { return e.type === "token_expired"; })) {
                            index_1.default.onRefreshTokenExpiration();
                        }
                        throw responseError;
                    }
                    else {
                        throw new ApiError(error_1.toString(), error_1, 500);
                    }
                    return [3, 5];
                case 5: return [2];
            }
        });
    });
}
var getDefaultHeaders = function (contentType) {
    var tokenPair = index_1.default.getUserToken();
    return __assign({ "X-Revision": index_1.default._revision, Authorization: tokenPair ? tokenPair.tokenType + " " + tokenPair.accessToken : index_1.default._apiKey }, (contentType !== false ? { "Content-Type": contentType } : {}));
};
var refreshTokenPairSubject = new rxjs_1.Subject();
var refreshTokenPairInProcess = false;
var fetchNewTokenPair = function () { return __awaiter(void 0, void 0, void 0, function () {
    var tokenPair, reqOptions, tokenRefreshParams, newToken, date, newTokenWithExpirationDate, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!refreshTokenPairInProcess) return [3, 4];
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                tokenPair = index_1.default.getUserToken();
                if (!tokenPair) {
                    throw new Error("No token");
                }
                refreshTokenPairInProcess = true;
                reqOptions = {
                    method: "POST",
                    body: JSON.stringify({
                        grant_type: "refresh_token",
                        refresh_token: tokenPair.refreshToken,
                        scope: "user_identity",
                    }),
                    headers: __assign(__assign({}, getDefaultHeaders("application/json")), { Authorization: index_1.default._apiKey }),
                };
                tokenRefreshParams = buildRequestParams("/oauth/token", reqOptions);
                return [4, callBackend(tokenRefreshParams.url, tokenRefreshParams.options)];
            case 2:
                newToken = _a.sent();
                date = new Date();
                date.setSeconds(date.getSeconds() + newToken.expiresIn - 30);
                newTokenWithExpirationDate = index_1.default.restoreUserToken(__assign(__assign({}, newToken), { dateOfExpiration: date.toISOString() }));
                refreshTokenPairSubject.next(newTokenWithExpirationDate);
                refreshTokenPairInProcess = false;
                return [3, 4];
            case 3:
                err_1 = _a.sent();
                refreshTokenPairInProcess = false;
                index_1.default.restoreUserToken(null);
                throw err_1;
            case 4: return [2];
        }
    });
}); };
var waitForTokenRefresh = function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2, new Promise(function (resolve, reject) {
                var sub = refreshTokenPairSubject.subscribe({
                    next: function (token) {
                        sub.unsubscribe();
                        resolve(token);
                    },
                });
                fetchNewTokenPair().catch(reject);
            })];
    });
}); };
var sendRequest = function (path, reqOptions, queryParams, contentType) {
    if (reqOptions === void 0) { reqOptions = {}; }
    if (contentType === void 0) { contentType = "application/json"; }
    return __awaiter(void 0, void 0, void 0, function () {
        var accessToken, defaultHeaders, builtParams;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    accessToken = index_1.default.getUserToken();
                    if (!(accessToken &&
                        Date.now() >= new Date(accessToken.dateOfExpiration).getTime() &&
                        path !== oauth_1.default.verification.url &&
                        path !== oauth_1.default.login.url)) return [3, 2];
                    return [4, waitForTokenRefresh()];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    defaultHeaders = getDefaultHeaders(contentType);
                    builtParams = buildRequestParams(path, __assign(__assign({}, reqOptions), { query: queryParams, headers: __assign(__assign({}, defaultHeaders), reqOptions.headers) }));
                    return [2, callBackend(builtParams.url, builtParams.options)];
            }
        });
    });
};
exports.default = sendRequest;
//# sourceMappingURL=fetch.js.map